/**
 * Full-screen absolute positioned container.
 * Used by Sequence to wrap its children.
 *
 * Written from scratch for Steve.AI.
 */

import React, { forwardRef, useMemo } from 'react';

const AbsoluteFillRefForwarding = (props, ref) => {
  const { style, ...other } = props;
  const mergedStyle = useMemo(() => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    ...style,
  }), [style]);

  return <div ref={ref} style={mergedStyle} {...other} />;
};

export const AbsoluteFill = forwardRef(AbsoluteFillRefForwarding);
